import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import {cn} from "../lib/utils";

function Tabs({className, ...props}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root data-slot="tabs" className={className} {...props} />;
}

function TabsList({className, ...props}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return <TabsPrimitive.List data-slot="tabs-list" className={cn("inline-flex items-center gap-md pl-md", className)} {...props} />;
}

// 4辺ボーダー。アクティブタブは border-b を背景色と同色にして底辺を消し、
// コンテンツ領域と一体化させる。区切り線は非アクティブタブの底辺が担う。
function TabsTrigger({className, ...props}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "z-10 -mb-px inline-flex items-center justify-center gap-xs rounded-t-md border border-border px-md py-sm text-sm font-bold whitespace-nowrap",
        "text-muted-foreground transition-colors hover:text-foreground",
        "focus-visible:outline-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] focus-visible:outline-1",
        "disabled:pointer-events-none disabled:opacity-50",
        "data-[state=active]:border-b-background data-[state=active]:bg-background data-[state=active]:text-foreground",
        className,
      )}
      {...props}
    />
  );
}

function TabsContent({className, ...props}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return <TabsPrimitive.Content data-slot="tabs-content" className={cn("flex-1 outline-none", className)} {...props} />;
}

export {Tabs, TabsList, TabsTrigger, TabsContent};
